/**
 * @param {number} value
 * @param {number} [decimals=2]
 * @returns {number}
 */
export const roundNumber = (value, decimals = 2) => {
  return Number(Number(Math.round(value + "e" + decimals) + "e-" + decimals));
};
